import { useRef, type ChangeEvent } from 'react';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import { ATTACHMENT_ACCEPT } from './attachmentRules';
import { ComposerIconButton } from './ComposerIconButton';

interface AttachFileButtonProps {
    onFiles: (files: File[]) => void;
}

function AttachFileButton({ onFiles }: AttachFileButtonProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files ?? []);
        // Reset so picking the same file again still fires a change.
        e.target.value = '';
        if (files.length > 0) onFiles(files);
    };

    return (
        <>
            <ComposerIconButton label="Attach a file" onClick={() => inputRef.current?.click()}>
                <PaperClipIcon className="w-5 h-5" />
            </ComposerIconButton>
            <input
                ref={inputRef}
                type="file"
                accept={ATTACHMENT_ACCEPT}
                onChange={handleChange}
                className="hidden"
                tabIndex={-1}
                aria-hidden="true"
            />
        </>
    );
}

export { AttachFileButton };
